import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=6ea13d1e&scoped=true"
import script from "./Competitions.vue?vue&type=script&lang=js"
export * from "./Competitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea13d1e",
  null
  
)

export default component.exports